<script lang="ts">
    import type { HydriaDocument } from 'hydria/HydriaDocument'
    import Modal from 'hydria/components/Modal.svelte'
    import TipTap from 'hydria/components/TipTapGen/index.svelte'
    import { type TGettext, gettext as _, resolve, tgettext } from 'hydria/services/gettext'

    interface Props {
        saved: string | undefined
        value: string | undefined
        helpText?: TGettext | undefined
        Document?: HydriaDocument | undefined
        label?: any
        isValid?: any
        save?: (newValue: string | undefined) => void
        close?: () => void
    }

    let { saved: savedValue, value, helpText = undefined, Document = undefined, label = tgettext('HTML'), isValid = (value: string | undefined) => true, save = (v) => {}, close = () => {} }: Props = $props()
    // let savedIsValid = isValid(savedValue)

    function keep() {
        save(value)
    }
    let isPristine = $derived(value == savedValue)
</script>

<style>
    .modal-header > div {
        font-size: 1.1rem;
    }
</style>

<svelte:window
    onkeydown={(e) => {
        if (e.key == 'Escape') close()
        else if (e.key == 'Enter' && e.ctrlKey && !isPristine && isValid(value)) keep()
    }}
/>

<Modal close={() => close()} modalClasses="modal-xl modal-cover">
    <div class="modal-header text-bg-primary">
        <div>{$resolve(label)}</div>
    </div>
    <div class="modal-body">
        <TipTap bind:value {Document} />
        {#if helpText != null}
            <div class="form-text text-muted">{$resolve(helpText)}</div>
        {/if}
    </div>
    <div class="modal-footer text-bg-light">
        <button type="button" class="btn btn-outline-secondary" onclick={() => close()}>{$_('Fermer')}</button>
        <button type="button" class="btn btn-primary" onclick={() => keep()} disabled={!isValid(value)}>{$_('Appliquer')}</button>
    </div>
</Modal>
